<template>
  <b-modal :id="id" centered>
    <b-img :src="image.url" fluid-grow></b-img>
    <template #modal-footer="{ close }">
      <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'

import { ImagePlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(ImagePlugin)
Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'image-modal',
  props: {
    id: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      required: true
    }
  },
  components: {
    // 
  }
};
</script>